/**
 * External Imports
 */
import { FC, useEffect, useState } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';

/**
 * Internal Imports
 */
import Discharges from './Discharges';
import Areas from './Areas';
import Encounters from './Encounters';
import Templates from './Templates';
import UsersList from './UsersList';
import QuestionBank from './QuestionBank';

/**
 * Global Type Definition Imports
 */
import { setAdminSearchTerm } from '../../redux/actions';
import { useUserRolesRef } from '../../services/UserRoles/userRoles';
import { useDebounceValue } from '../../utils/debouncers';

const Admin: FC<{}> = () => {
  const dispatch = useDispatch();
  const { isUserAdmin } = useUserRolesRef();

  const [searchTerm, setSearchTerm] = useState<string>('');

  const debouncedSearchTerm = useDebounceValue(searchTerm, 350);

  useEffect(() => {
    dispatch(setAdminSearchTerm(debouncedSearchTerm));
  }, [debouncedSearchTerm]);

  return (
    <div>
      <Routes>
        <Route
          path="users"
          element={
            <UsersList searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          }
        />
        <Route path="encounters" element={<Encounters />} />
        <Route path="question-bank" element={<Outlet />}>
          <Route
            index
            element={
              <QuestionBank
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            }
          />
          <Route
            path=":templateConfigId"
            element={
              <QuestionBank
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            }
          />
        </Route>
        <Route
          path="discharges"
          element={
            <Discharges searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          }
        />
        <Route path="areas" element={<Areas />} />
        <Route path="templates" element={<Templates />} />
        <Route
          path="*"
          element={
            isUserAdmin ? (
              <Navigate to="users" replace />
            ) : (
              <Navigate to="areas" replace />
            )
          }
        />
      </Routes>
    </div>
  );
};

export default Admin;
